import type { IPDFViewerProps } from '@/components/Organisms/PDFViewer/PDFViewer';
import dynamic from 'next/dynamic';

export const CsrPdfViewer = dynamic<IPDFViewerProps>(
    () => import('../../Organisms/PDFViewer/PDFViewer').then((mod) => mod.PDFViewer),
    {
        ssr: false,
    }
);
